import React, { useState, useEffect } from "react";
import { getImageUrl } from "../../utils/imageUtils";
import { useTheme } from "../../context/ThemeContext";

const Hero = ({ slides = [] }) => {
  const { colors } = useTheme();
  const [currentSlide, setCurrentSlide] = useState(0);

  // Default slide if none provided
  const defaultSlides = [
    {
      title: "Welcome to Gurukul",
      subtitle: "Your future starts here",
      image: "",
    },
  ];

  const safeSlides = slides && slides.length > 0 ? slides : defaultSlides;
  const currentSlideData = safeSlides[currentSlide] || safeSlides[0];

  useEffect(() => {
    if (safeSlides.length > 1) {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => (prev + 1) % safeSlides.length);
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [safeSlides.length]);

  const openRegistration = () => {
    // Dispatch a global event that Header listens to, to open the registration modal
    const event = new Event("open-registration-modal");
    window.dispatchEvent(event);
  };

  return (
    <section
      style={{ position: "relative", height: "100vh", overflow: "hidden" }}
    >
      <style>{`
                @keyframes kenburns-left {
                    0% { transform: scale(1) translate3d(0, 0, 0); }
                    100% { transform: scale(1.12) translate3d(-2%, -2%, 0); }
                }
                @keyframes kenburns-right {
                    0% { transform: scale(1) translate3d(0, 0, 0); }
                    100% { transform: scale(1.12) translate3d(2%, -2%, 0); }
                }
                @keyframes fadeUp {
                    0% { transform: translateY(16px); opacity: 0; }
                    100% { transform: translateY(0); opacity: 1; }
                }
            `}</style>
      {safeSlides.map((slide, index) => {
        const imageUrl = getImageUrl(slide.image);
        const isActive = currentSlide === index;
        const kenburns = index % 2 === 0 ? "kenburns-left" : "kenburns-right";
        return (
          <div
            key={index}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundImage: imageUrl ? `url(${imageUrl})` : "none",
              backgroundSize: "cover",
              backgroundPosition: "center",
              opacity: isActive ? 1 : 0,
              transition: "opacity 900ms ease-in-out",
              willChange: "transform, opacity",
              animation: isActive
                ? `${kenburns} 9s ease-in-out forwards`
                : "none",
            }}
          />
        );
      })}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background:
            "linear-gradient(135deg, rgba(14, 165, 233, 0.65) 0%, rgba(3, 105, 161, 0.8) 100%)",
        }}
      />
      <div
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          color: "white",
          padding: "0 2rem",
        }}
      >
        <div style={{ maxWidth: "800px" }}>
          <h1
            style={{
              fontSize: "clamp(2.5rem, 5vw, 3.5rem)",
              fontWeight: "800",
              marginBottom: "1rem",
              textShadow: "2px 2px 4px rgba(0,0,0,0.3)",
              animation: "fadeUp 700ms ease forwards",
              opacity: 0,
            }}
          >
            {currentSlideData?.title || "Welcome to Gurukul"}
          </h1>
          <p
            style={{
              fontSize: "clamp(1.2rem, 3vw, 1.5rem)",
              marginBottom: "2rem",
              textShadow: "1px 1px 2px rgba(0,0,0,0.3)",
              animation: "fadeUp 900ms ease 120ms forwards",
              opacity: 0,
            }}
          >
            {currentSlideData?.subtitle || "Your future starts here"}
          </p>
          <button
            onClick={openRegistration}
            style={{
              background: colors.buttonPrimary,
              color: colors.buttonText,
              border: "none",
              padding: "1rem 2rem",
              fontSize: "1.1rem",
              fontWeight: "600",
              borderRadius: "0.5rem",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
              textDecoration: "none",
              animation: "fadeUp 900ms ease 220ms forwards",
              opacity: 0,
            }}
          >
            Register
          </button>
        </div>
      </div>
      {safeSlides.length > 1 && (
        <div
          style={{
            position: "absolute",
            bottom: "2rem",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "0.5rem",
            zIndex: 3,
          }}
        >
          {safeSlides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              style={{
                width: "12px",
                height: "12px",
                borderRadius: "50%",
                border: "2px solid white",
                background: currentSlide === index ? "white" : "transparent",
                cursor: "pointer",
                transition: "all 0.3s ease",
                transform: currentSlide === index ? "scale(1.15)" : "scale(1)",
              }}
            />
          ))}
        </div>
      )}
    </section>
  );
};
export default Hero;
